import * as Services from "../../../Service/Service"
import * as Url from '../../../Service/Url';

export const verifyOtp = async(value) => {
  let res = await Services.GET(Url.VERIFY_API_URL + value)
  return res;
};
export const sendQrEmail = async (email) =>{
  let res = await Services.POST(Url.SEND_QR_EMAIL,{ToEmail:email});
  return res;
}